module.exports = __webpack_public_path__ + "static/img/active1.7e9b63d9.png";